// extracted by mini-css-extract-plugin
export default {"formInput":"FormInput_formInput__Fm2pO","invalidReason":"FormInput_invalidReason__4sXIc"};